export enum WatchTowerViews {
  DEVICE_LIST = 'DEVICE_LIST',
  MAP_VIEW = 'MAP_VIEW',
  SPLIT_VIEW = 'SPLIT_VIEW',
}

export const WATCH_TOWER_VIEWS_VALUES = Object.keys(WatchTowerViews).map(key => WatchTowerViews[key as keyof typeof WatchTowerViews]);
